import React from "react";

const InputWithIcon = ({ icon: Icon, className = "", ...inputProps }) => {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <Icon className="h-5 w-5 text-gray-400" />
      </div>
      <input
        className={`block w-full rounded-md border border-gray-300 py-2.5 pl-10 pr-3 shadow-sm dark:border-navy-600 dark:bg-navy-700 dark:text-white sm:text-sm ${className}`}
        {...inputProps}
      />
    </div>
  );
};

export default InputWithIcon;
